<template>
    <b-tabs id="tabsRsaGestioneCentroDiurnoList" ref="tabsRsaGestioneCentroDiurno" v-model="activeTabIndex" nav-wrapper-class="sa-tab-items" content-class="mt-3" class="sa-tab" style="height: 100%; padding-bottom: 25px" fill @input="onInputTabs">
        <b-tab id="tbRsaGestionePresenti" title="Programmati" active>
            <rsa-gestione-pazienti-adi-programmati-component ref="cmpRsaGestionePazientiAdiProgrammati"></rsa-gestione-pazienti-adi-programmati-component>
        </b-tab>
    </b-tabs>
</template>

<script>
import RsaGestionePazientiAdiProgrammatiComponent from "./RsaGestionePazientiAdiProgrammatiComponent.vue";
export default {
    components: { RsaGestionePazientiAdiProgrammatiComponent },
    data() {
        return {
            activeTabIndex: 0,
            filtroGestionePazientiAdi: null,
        };
    },
    methods: {
        init(filtroGestionePazientiAdi) {
            this.filtroGestionePazientiAdi = filtroGestionePazientiAdi;
            this.tabSelection();
        },
        onInputTabs() {
            this.tabSelection();
        },
        tabSelection() {
            this.$emit("tabChange", this.activeTabIndex);
            switch (this.activeTabIndex) {
                case 0:
                    this.$refs.cmpRsaGestionePazientiAdiProgrammati.loadData(this.filtroGestionePazientiAdi);
                    break;
            }
        },
        salvaProgrammazione() {
            this.$refs.cmpRsaGestionePazientiAdiProgrammati.salvaProgrammazione();
        },
    },
};
</script>

<style></style>
